import { defineView } from "@/ReactSetup/view-definitions";

const definition = defineView({
    name: "Overlay",
    component: () => require("./overlay-view")
});

export default definition;
